export default "__VITE_ASSET__PtjtJA2n__"